import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import {Router, NavigationEnd} from "@angular/router";
import { LOCALE_ID, Inject } from '@angular/core';
import { environment } from './../environments/environment';
import * as confetti from 'canvas-confetti';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from "rxjs/operators";
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Videyo';
  languageList = [{ code: 'en', label: 'English' }, { code: 'ar', label: 'Arabic' }, { code: 'fr', label: 'French' }];
  loading = false;
  constructor(private activatedRoute:    ActivatedRoute, private titleService: Title, @Inject(LOCALE_ID) protected localeId: string, public router: Router,  private spinner: NgxSpinnerService) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
          gtag('config', environment.analytics, 
                {
                  'page_path': event.urlAfterRedirects
                }
               );
       }
      }),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
            let child = this.activatedRoute.firstChild;
            while (child) {
                if (child.firstChild) {
                    child = child.firstChild;
                } else if (child.snapshot.data &&    child.snapshot.data['title']) {
                    return child.snapshot.data['title'];
                } else {
                    return null;
                }
            }
            return null;
        })
    ).subscribe( (data: any) => {
        if (data) {
            this.titleService.setTitle(data + ' - '+ environment.name);
        }
    });
  }
  ngOnInit() {
}
ngAfterViewInit()
{
this.loading = true;
}
}